// extracted by mini-css-extract-plugin
export default {"empty":"empty-user_empty__00wCX","captionContainer":"empty-user_captionContainer__N45Ut","caption":"empty-user_caption__xG5uJ"};